/* eslint-disable react/no-array-index-key */
import React from 'react';
import { describe, PropTypes } from '@elliemae/ds-props-helpers';
import { styled, color, border, withTheme, truncate, __UNSAFE_SPACE_TO_DIMSUM } from '@elliemae/ds-system';
import { Group } from '@elliemae/ds-shared';
import { Grid } from '@elliemae/ds-grid';
import { StyledCard as Card } from './StyledCard.js';

const GroupGrid = styled(Grid)`
  ${Card} {
    border-top: none;
  }

  ${({ theme, withTopBorder }) => (withTopBorder ? `border-top: ${border(theme.colors.neutral['100'])}` : '')}
`;

const GroupTitle = styled.span`
  ${truncate()}
`;

const GroupTitleGrid = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 ${(props) => props.theme.space.xs};
  font-size: ${(props) => `calc(${__UNSAFE_SPACE_TO_DIMSUM(props.theme.space.m)} / 2)`};
  ${color('neutral', '700')}
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  background-color: ${(props) => props.theme.colors.brand['200']};
  border-top: ${(props) => border(props.theme.colors.brand['300'])};
  line-height: ${(props) => __UNSAFE_SPACE_TO_DIMSUM(props.theme.space.m)};
  @media (min-width: 1024px) {
    background-color: ${(props) => props.theme.colors.neutral['080']};
    border-top: ${(props) => border(props.theme.colors.neutral['080'])};
  }
`;

const MobileCardGroup = ({
  children,
  theme,
  title,
  action,
  activeValue,
  allowMultipleOpen = false,
  onChange = () => null,
}) => {
  const rows = !title ? ['auto'] : [__UNSAFE_SPACE_TO_DIMSUM(theme.space.m), 'auto'];

  return (
    <Group activeValue={activeValue} multiple={allowMultipleOpen} onChange={onChange}>
      <GroupGrid withTopBorder={!title} rows={rows}>
        {!!title && (
          <GroupTitleGrid pl="xxs">
            <GroupTitle>{title}</GroupTitle>
            {action}
          </GroupTitleGrid>
        )}
        <Grid>
          {React.Children.map(
            children,
            (child, idx) =>
              React.cloneElement(child, {
                key: idx,
                value: idx,
                idx,
              }),
            null,
          )}
        </Grid>
      </GroupGrid>
    </Group>
  );
};

const props = {
  theme: PropTypes.object.isRequired.description(''),
  /**
   * Defines group title
   */
  title: PropTypes.string.description(''),
  /**
   * Pass one or more Mobile Cards to render as a group
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired.description(''),
  /**
   * Group header addon
   */
  action: PropTypes.element.description(''),
  /**  */
  activeValue: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]).description(''),
  /**  */
  allowMultipleOpen: PropTypes.bool.description(''),
  /**  */
  onChange: PropTypes.func.description(''),
};

MobileCardGroup.displayName = 'MobileCardGroup';
const DSMobileCardGroupWithSchema = describe(MobileCardGroup);

DSMobileCardGroupWithSchema.propTypes = props;

export { DSMobileCardGroupWithSchema };

export default withTheme(MobileCardGroup);
